// extracted by mini-css-extract-plugin
module.exports = {"root":"default_root__Fj5fX","link":"default_link__b6NtG","title":"default_title__efOJ2"};